"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAsset extends new_item_1.default {
    constructor(newAsset) {
        super();
        this.widgetBoardId = newAsset.widgetBoardId;
        this.lastContacted = newAsset.lastContacted;
        this.nbIotEcl = newAsset.nbIotEcl;
        this.groupIds = newAsset.groupIds;
        if (!newAsset.name) {
            throw Error("name required");
        }
        this.name = newAsset.name;
        this.siteName = newAsset.siteName;
        this.siteId = newAsset.siteId;
        this.siteTimezone = newAsset.siteTimezone;
        this.impKwh = newAsset.impKwh;
        this.parentAsset = newAsset.parentAsset;
        this.currentState = newAsset.currentState;
        this.userState = newAsset.userState;
        this.sku = newAsset.sku;
        this.code = newAsset.code;
        this.dataType = newAsset.dataType;
        this.deviceCategory = newAsset.deviceCategory;
        this.deviceCategoryColor = newAsset.deviceCategoryColor;
        this.deviceCategoryIcon = newAsset.deviceCategoryIcon;
        this.generation = newAsset.generation;
        this.assetIndex = newAsset.assetIndex;
        this.ble = newAsset.ble;
        this.boostFinish = newAsset.boostFinish;
        this.snoozeFinish = newAsset.snoozeFinish;
        this.loadType = newAsset.loadType;
        this.gatewayId = newAsset.gatewayId;
        this.gatewayName = newAsset.gatewayName;
        this.applianceType = newAsset.applianceType;
        this._permission = newAsset._permission;
        this.serialNo = newAsset.serialNo;
        this.readOnly = newAsset.readOnly;
        this.locked = newAsset.locked;
        this.children = newAsset.children;
        this.disconnected = newAsset.disconnected;
        this.gatewayDisconnected = newAsset.gatewayDisconnected;
        this.clampNameTwo = newAsset.clampNameTwo;
        this.clampSize = newAsset.clampSize;
        this.climaxClamp = newAsset.climaxClamp;
        this.triggerRules = newAsset.triggerRules;
        this.alertRules = newAsset.alertRules;
        this.advancedRules = newAsset.advancedRules;
        this.consumption = newAsset.consumption;
        this.consumptionPulse = newAsset.consumptionPulse;
        this.gasPulse = newAsset.gasPulse;
        this.waterPulse = newAsset.waterPulse;
        this.voc = newAsset.voc;
        this.open = newAsset.open;
        this.co2 = newAsset.co2;
        this.pressure = newAsset.pressure;
        this.waterPulseHot = newAsset.waterPulseHot;
        this.temperature = newAsset.temperature;
        this.humidity = newAsset.humidity;
        this.light = newAsset.light;
        this.current = newAsset.current;
        this.occupancy = newAsset.occupancy;
        this.assetSignalStrength = newAsset.assetSignalStrength;
        this.assetBatteryVoltage = newAsset.assetBatteryVoltage;
        this.assetBatteryAlarm = newAsset.assetBatteryAlarm;
        this.assetBatteryPercent = newAsset.assetBatteryPercent;
        this.firmwareTarget = newAsset.firmwareTarget;
        this.assetFirmwareVersion = newAsset.assetFirmwareVersion;
        this.assetFirmwareProgress = newAsset.assetFirmwareProgress;
        this.demandPhaseOne = newAsset.demandPhaseOne;
        this.demandPhaseTwo = newAsset.demandPhaseTwo;
        this.demandPhaseThree = newAsset.demandPhaseThree;
        this.pfPhaseOne = newAsset.pfPhaseOne;
        this.pfPhaseTwo = newAsset.pfPhaseTwo;
        this.pfPhaseThree = newAsset.pfPhaseThree;
        this.virtualLink = newAsset.virtualLink;
        this.doReconfigure = newAsset.doReconfigure;
        this.modbusId = newAsset.modbusId;
        this.anomalyDetection = newAsset.anomalyDetection;
        this.lowBattery = newAsset.lowBattery;
        this.lowSignal = newAsset.lowSignal;
        this.fault = newAsset.fault;
        this.intermittent = newAsset.intermittent;
        this.anomaly = newAsset.anomaly;
        this.modbusDetails = newAsset.modbusDetails;
    }
}
exports.default = NewAsset;
//# sourceMappingURL=new-asset.js.map